import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import brandLogo from "../../assets/logo/brandLogo.png";
import FusionLogo from "../../assets/logo/FusionLogo.png";
import Fontstyling from "../common/comman";
import Required from "../Required";
import barIcon from "../../assets/icon/baricon.svg";
import logoutIcon from "../../assets/icon/power-off-solid.svg";
import {
  ACGHealthInsightsMenu,
  adminType,
  ClinicalConsultingSubMenu,
  HEADER_MENU,
  HEADER_MENU_CLIENT,
  ResourcesSubMenu,
  serviceRequest,
  IAReportSubMenu
} from "../../Utils/constants";
import { useDispatch, useSelector } from "react-redux";
import Notification from "../common/Notification/index";
import { getNotificationData } from "../../api/User/commonApi";
import {
  Button,
  Modal,
  NavDropdown,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import LogoutModal from "../common/Modal/LogoutModal";
import "./style.css";
import { Icon } from "@iconify/react";
import ReactTooltip from "react-tooltip";
import { flexbox } from "@mui/system";
import EmpoweRxLogo from "../../assets/logo/EmpoweRx.png";

const Header = ({
  setLeftMenuIsOpen,
  setRightMenuIsOpen,
  navigate,
  navRef,
}) => {
  const user = useSelector((state) => state.userDetails.value);
  const [notificationData, setNotificationData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [adminDropdown, setAdminDropdown] = useState(false);
  const [isClinicalDropdown, setClinicalDropdown] = useState(false);
  const [isResourcesDropdown, setResourcesDropdown] = useState(false);
  const [isIAreportDropdown, setIAreportDropdown] = useState(false);
  const location = useLocation();
  const linkStyle = {
    textDecoration: "none",
    color: "black",
    fontWeight: "700",
    padding: "10px",
  };
  const activeStyle = { ...linkStyle, borderBottom: "8px solid #00AEEF" };

  useEffect(() => {
    getNotification();
  }, []);

  const getNotification = () => {
    let NotifLoginUserStatus =
    user?.UserRole === "User" ||
    user?.UserRole === "Clinician" ||
    user?.UserRole === "Pharmacy" ||
    user?.UserRole === "Client"
      ? 2
      : 1;
  let userId = user?.UserRole === "Client" ? user?.id : user?.UD_id;
    getNotificationData(userId, NotifLoginUserStatus)
      .then((res) => setNotificationData(res.data))
      .catch((err) => console.log(err));
  };

  return (
    <>
      <LogoutModal
        show={showModal}
        setModal={setShowModal}
        navigate={navigate}
      />
      <nav
        className="navbar bg-body-tertiary pe-lg-4 ps-md-3 pe-1 py-md-3 py-2"
        style={{ borderBottom: "1px solid black" }}
        ref={navRef}
      >
        <div className="container-fluid d-flex text-nowrap flex-nowrap align-items-center px-0 ps-2 ps-md-0 gap-3 ">
          <div
            onClick={() => {
              navigate("/Welcome", {
                state: {
                  email:
                    user?.UserRole !== "Client"
                      ? user?.UD_emp_email
                      : user?.emailId,
                  name:
                    user?.UserRole !== "Client"
                      ? user?.UD_emp_name
                      : user?.firstName + " " + user?.lastName,
                  role: user?.UserRole
                },
              });
            }}
            className="navbar-brand d-flex align-items-start cursor-pointer"
          >
            {location.pathname.match("EmpoweRx") ?
              <img
                src={EmpoweRxLogo}
                alt="logo"
                className="img-fluid me-2"
                style={{width:260, minWidth:260}}
              /> :
              <div className="d-flex align-items-center">
                   <img
                          src={brandLogo}
                          width="260"
                          alt="logo"
                          style={{minWidth:"240px"}}
                          className="img-fluid me-2"
                        />
                
              </div>
                       
            }
          </div>
          <div
            className="d-flex align-items-center hide-scrollbar"
            // style={{ overflowX: "scroll" }}
          >              
            {user?.UserRole === "Client"? (
              <div className="d-xl-flex d-none gap-2 align-items-center">
                <div>
                  {HEADER_MENU_CLIENT.map(({ id, title, pathName }) => {
                    if (id == 1 && user?.gpoId > 0) {
                      return (
                        <NavLink
                          to={pathName}
                          style={({ isActive }) =>
                            isActive ? activeStyle : linkStyle
                          }
                          key={id}
                        >
                          {title}
                        </NavLink>
                      );
                    }else if (id === 2) {
                      return (
                        <OverlayTrigger
                          placement={"bottom"}
                          trigger={["hover", "focus"]}
                          overlay={
                            <Tooltip show={!showModal}>IA Dashboard</Tooltip>
                          }
                        >
                          <NavLink
                            to={pathName}
                            style={({ isActive }) =>
                              isActive ? activeStyle : linkStyle
                            }
                            key={id}
                          >
                            <img src={FusionLogo} alt="IA Dashboard" width={25} />
                          </NavLink>
                        </OverlayTrigger>
                      );
                    }
                  })}
                </div>
                {/* <div>
                  <OverlayTrigger
                    placement={"bottom"}
                    trigger={["hover", "focus"]}
                    overlay={
                      <Tooltip show={!showModal}>IA Dashboard</Tooltip>
                    }
                  >
                    <NavLink
                      to={"/report/sisense"}
                      style={({ isActive }) =>
                        isActive ? activeStyle : linkStyle
                      }
                    >
                      <img src={FusionLogo} alt="IA Dashboard" width={25} />
                    </NavLink>
                  </OverlayTrigger>
                </div> */}
              </div>
            ) : (
              <div className="d-xl-flex d-none gap-2 align-items-center">
                {HEADER_MENU.map(({ id, title, pathName }) => {
                  if (id === 2) {
                    return (
                      <>
                        <NavDropdown
                          show={dropdown}
                          title="Health Insights"
                          style={{
                            textDecoration: "none",
                            padding: "10px",
                            color: "black",
                            fontWeight: "700",
                            borderBottom: location.pathname.match(
                              "ACGHealthInsights"
                            )
                              ? "8px solid #00AEEF"
                              : "",
                          }}
                          className="rounded-0"
                          onMouseEnter={(e) => {
                            setDropdown(true);
                          }}
                          onMouseLeave={() => {
                            setDropdown(false);
                          }}
                          id="nav-dropdown"
                        >
                          {" "}
                          {ACGHealthInsightsMenu.map((el, index) =>
                            user?.UserRole === "Admin" ? (
                              <NavDropdown.Item
                                as={Link}
                                className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                                to={el.path}
                                style={
                                  location.pathname.includes(`${el.pathName}`)
                                    ? {
                                        backgroundColor: "#00aeef",
                                        color: "white",
                                        textDecoration: "none",
                                      }
                                    : {}
                                }
                                onClick={() => setDropdown(false)}
                              >
                                <span>
                                  <Icon icon={el.icon} width={24} height={28} />
                                </span>
                                <div
                                  style={{
                                    ...Fontstyling.secondHeading,
                                    color:
                                      location.pathname.includes(
                                        `${el.pathName}`
                                      ) && "white",
                                    letterSpacing: "0.1px",
                                  }}
                                >
                                  {el.title}
                                </div>
                              </NavDropdown.Item>
                            ) : (
                              el.id !== 1 && (
                                <NavDropdown.Item
                                  as={Link}
                                  className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                                  to={el.path}
                                  style={
                                    location.pathname.includes(`${el.pathName}`)
                                      ? {
                                          backgroundColor: "#00aeef",
                                          color: "white",
                                          textDecoration: "none",
                                        }
                                      : {}
                                  }
                                  onClick={() => setDropdown(false)}
                                >
                                  <span>
                                    <Icon
                                      icon={el.icon}
                                      width={24}
                                      height={28}
                                    />
                                  </span>
                                  <div
                                    style={{
                                      ...Fontstyling.sidebarheading,
                                      color:
                                        location.pathname.includes(
                                          `${el.pathName}`
                                        ) && "white",
                                      letterSpacing: "0.1px",
                                    }}
                                  >
                                    {el.title}
                                  </div>
                                </NavDropdown.Item>
                              )
                            )
                          )}
                        </NavDropdown>
                      </>
                    );
                  } else if (id === 4) {
                    return (
                      <>
                        <NavDropdown
                          show={isResourcesDropdown}
                          title="Resources"
                          style={{
                            textDecoration: "none",
                            padding: "10px",
                            color: "black",
                            fontWeight: "700",
                            borderBottom: location.pathname.match("resourcecenter") ? "8px solid #00AEEF" : "",
                          }}
                          className="rounded-0 w-auto"
                          onMouseEnter={(e) =>setResourcesDropdown(true)}
                          onMouseLeave={(e) =>setResourcesDropdown(false)}
                          id="nav-dropdown"
                        >
                          {ResourcesSubMenu.map((el, index) => {
                              return (
                                <NavDropdown.Item
                                  as={Link}
                                  target={el.title === "Resource Center" ? '_self' : '_blank'}
                                  className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                                  to={el.pathName}
                                  style={
                                    location.pathname.includes(`${el.pathName}`)
                                      ? {
                                          backgroundColor: "#00aeef",
                                          color: "white",
                                          textDecoration: "none",
                                        }
                                      : {}
                                  }
                                  onClick={() => setResourcesDropdown(false)}
                                >
                                <div
                                  style={{
                                    ...Fontstyling.secondHeading,
                                    color:
                                      location.pathname.includes(
                                        `${el.pathName}`
                                      ) && "white",
                                    letterSpacing: "0.1px",
                                  }}
                                >
                                  {el.title}
                                </div>
                              </NavDropdown.Item>
                              )
                          })}
                        </NavDropdown>
                      </>
                    );
                  
                  } else if (id === 5) {
                    // return (
                    //   <OverlayTrigger
                    //     placement={"bottom"}
                    //     trigger={["hover", "focus"]}
                    //     overlay={
                    //       <Tooltip show={!showModal}>IA Dashboard</Tooltip>
                    //     }
                    //   >
                    //     <NavLink
                    //       to={pathName}
                    //       style={({ isActive }) =>
                    //         isActive ? activeStyle : linkStyle
                    //       }
                    //       key={id}
                    //     >
                    //       <img src={FusionLogo} alt="IA Dashboard" width={25} />
                    //     </NavLink>
                    //   </OverlayTrigger>
                    // );
                    return (
                      <>
                        <NavDropdown
                          show={isIAreportDropdown}
                          title={<img src={FusionLogo} alt="IA Dashboard" width={25} />}
                          style={{
                            textDecoration: "none",
                            padding: "10px",
                            color: "black",
                            fontWeight: "700",
                            borderBottom: location.pathname.match("/report/") ? "8px solid #00AEEF" : "",
                          }}
                          className="rounded-0 w-auto"
                          onMouseEnter={(e) =>setIAreportDropdown(true)}
                          onMouseLeave={(e) =>setIAreportDropdown(false)}
                          id="nav-dropdown"
                        >
                          {IAReportSubMenu.map((el, index) => {
                              return (
                                <NavDropdown.Item
                                  as={Link}
                                  //target={el.title === "Resource Center" ? '_self' : '_blank'}
                                  className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                                  to={el.pathName}
                                  style={
                                    location.pathname.includes(`${el.pathName}`)
                                      ? {
                                          backgroundColor: "#00aeef",
                                          color: "white",
                                          textDecoration: "none",
                                        }
                                      : {}
                                  }
                                  onClick={() => setIAreportDropdown(false)}
                                >
                                <div
                                  style={{
                                    ...Fontstyling.secondHeading,
                                    color:
                                      location.pathname.includes(
                                        `${el.pathName}`
                                      ) && "white",
                                    letterSpacing: "0.1px",
                                  }}
                                >
                                  {el.title}
                                </div>
                              </NavDropdown.Item>
                              )
                          })}
                        </NavDropdown>
                      </>
                    );
                  } else if (id === 7) {
                    return (
                      <div onClick={(e) => {}} key={id}>
                        <a
                          className="nav-link"
                          href="https://login.cgt.us/cas/login?service=https%3A%2F%2Finfusedanalytics.hba.cgt.us%2Flogin%2Fcas"
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "black",
                            fontWeight: 700,
                            padding: "10px",
                          }}
                        >
                          {title}
                        </a>
                      </div>
                    );
                  } else if (
                    id === 9 &&
                    (user?.IsClinicalIntakerights === 1 ||
                      user?.UserRole === "Admin" ||
                      user?.UserRole === "Clinician")
                  ) {
                    return (
                      <>
                        <NavDropdown
                          show={isClinicalDropdown}
                          title="Clinical Consulting"
                          style={{
                            textDecoration: "none",
                            padding: "10px",
                            color: "black",
                            fontWeight: "700",
                            borderBottom: location.pathname.match(
                              "clinicalconsulting"
                            )
                              ? "8px solid #00AEEF"
                              : "",
                          }}
                          className="rounded-0"
                          onMouseEnter={(e) => {
                            setClinicalDropdown(true);
                          }}
                          onMouseLeave={() => {
                            setClinicalDropdown(false);
                          }}
                          id="nav-dropdown"
                        >
                          {ClinicalConsultingSubMenu.map((el, index) => (
                            <a
                            href={el.hyperlink}
                            target="_blank"
                            className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                            style={{
                              color: "black",
                              fontWeight: 700,
                              padding: "10px",
                              
                            }}
                          >
                           <span>
                                <img
                                   src={el.icon}
                                   width={20}
                                   className="rounded-5"
                                 />
                               </span>
                               <div
                               style={{
                                   ...Fontstyling.sidebarheading,
                                  color:
                                     location.pathname.includes(
                                       `${el.pathName}`
                                     ) && "white",
                                   letterSpacing: "0.1px",
                                   fontSize: "12px",
                                 }}
                             >
                               {el.title}
                               </div>
                          </a>
                          
                          ))}
                        </NavDropdown>
                      </>
                    );
                  } else if (
                    (id !== 3 && id !== 6 && id !== 9) ||
                    (id === 3 &&
                      (user?.IsEmpoweRx === 1 || user?.UserRole === "Admin" || user?.UserRole === "Pharmacy")) ||
                    (id === 6 &&
                      (user?.IsClinicalIntakerights === 1 ||
                        user?.UserRole === "Admin" || user?.UserRole === "Clinician"))
                  ) {
                    return (
                      <NavLink
                        to={pathName}
                        style={({ isActive }) =>
                          isActive ? activeStyle : linkStyle
                        }
                        key={id}
                      >
                        {title}
                      </NavLink>
                    );
                  }
                })}

                {user?.UserRole === "Admin" ? (
                  // <NavDropdown
                  //   show={adminDropdown}
                  //   title="System Admin"
                  //   style={{
                  //     textDecoration: "none",
                  //     padding: "10px",
                  //     color: "white",
                  //     fontWeight: "700",
                  //   }}
                  //   className="primary-button px-4"
                  //   // onClick={() => navigate("/admin")}
                  //   onMouseEnter={(e) => {
                  //     setAdminDropdown(true);
                  //   }}
                  //   onMouseLeave={() => {
                  //     setAdminDropdown(false);
                  //   }}
                  //   id="nav-dropdown"
                  // >
                  //   {" "}
                  //   {adminType.map((el, index) => (
                  //     <NavDropdown.Item
                  //       as={Link}
                  //       className="d-flex align-items-center gap-3 py-2 text-decoration-none"
                  //       to={el.path}
                  //       style={
                  //         location.pathname.includes(`${el.path}`)
                  //           ? {
                  //               backgroundColor: "#00aeef",
                  //               color: "white",
                  //               textDecoration: "none",
                  //             }
                  //           : {}
                  //       }
                  //       onClick={() => setAdminDropdown(false)}
                  //     >
                  //       <span>
                  //         <Icon icon={el.icon} width={24} height={28} />
                  //       </span>
                  //       <div
                  //         style={{
                  //           ...Fontstyling.secondHeading,
                  //           color:
                  //             location.pathname.includes(`${el.path}`) &&
                  //             "white",
                  //           letterSpacing: "0.1px",
                  //         }}
                  //       >
                  //         {el.title}
                  //       </div>
                  //     </NavDropdown.Item>
                  //   ))}
                  // </NavDropdown>
                  <NavLink
                  to={"/admin"}
                  style={{
                        textDecoration: "none",
                        padding: "10px",
                        color: "white",
                        fontWeight: "700",
                      }}
                  className="primary-button px-4"
                >
                  {"Admin"}
                </NavLink>
                ) : (
                  <NavLink
                    to={"/servicerequest"}
                    style={({ isActive }) =>
                      isActive ? activeStyle : linkStyle
                    }
                  >
                    {"Service Request"}
                  </NavLink>
                )}
              </div>
            )}
            <div className="d-xl-flex d-none align-items-center gap-1 ps-3">
              <Notification
                data={notificationData}
                setData={setNotificationData}
                getNotification={getNotification}
                navigate={navigate}
              />
              <OverlayTrigger
                placement={"bottom"}
                trigger={["hover", "focus"]}
                overlay={<Tooltip show={!showModal}>Log Out</Tooltip>}
              >
                <Button
                  className="p-2 bg-transparent border-0"
                  onClick={() => setShowModal(true)}
                >
                  <img
                    src={logoutIcon}
                    width="20"
                    height={"16"}
                    alt="logout icon"
                    className=""
                  />
                </Button>
              </OverlayTrigger>
              {/* <Button className="p-2 bg-transparent border-0">
                 <img
                src={logoutIcon}
                width="20"
                alt="logout icon"
                className=""
                onClick={() => setShowModal(true)}
              />
              </Button> */}
            </div>
            <div className="d-xl-none d-flex align-items-center gap-2 pe-2">
              <Notification
                data={notificationData}
                setData={setNotificationData}
                getNotification={getNotification}
                navigate={navigate}
              />
              <Button
                className="p-2 bg-transparent border-0"
                onClick={() => setShowModal(true)}
              >
                {" "}
                <img
                  src={logoutIcon}
                  width="18"
                  height={"16"}
                  alt="logout icon"
                  onClick={() => setShowModal(true)}
                />
              </Button>

              <img
                src={barIcon}
                width="32"
                alt="barIcon"
                onClick={() => setRightMenuIsOpen(true)}
              />
            </div>
          </div>
        </div>
      </nav>
      <div
        className="text-end my-2 px-2 pe-md-4 d-flex justify-content-between align-items-center"
        style={Fontstyling.secondaryparagraph}
      >
        <div onClick={() => setLeftMenuIsOpen(true)}>
          <img
            src={barIcon}
            width="32"
            alt="barIcon"
            className="me-3 d-lg-none"
          />
        </div>
      </div>
    </>
  );
};

export default Header;
